const handleDeleteDocumentFileModalAction = {
  confirm: '¿Realmente desea eliminar este archivo?',
  title: 'ELIMINAR ARCHIVO'
};

export default handleDeleteDocumentFileModalAction;
